<template>
  <v-row>
    <v-col cols="12">
      <HeaderWidget :header-text="companyInfo.companyName" type="Welcome" />
    </v-col>
  </v-row>

  <v-row>
    <v-col>
      <Widget class="fill-height">
        <v-card style="border-radius: 6px" flat class="fill-height">
          <div class="text-left">
            <v-card-text class="pa-6">
              <h2 class="text-left mb-2">Company information</h2>
              <div class="ml-2">
                <v-row no-gutters>
                  <v-col><span class="company-info">Tier level</span></v-col>
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.tierLevel
                  }}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col><span class="company-info">Country</span></v-col>
                  <v-col class="text-right">
                    <CountryText
                      :country-code="companyInfo.operatingCountryCode"
                    />
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col
                    ><span class="company-info"
                      >Organisation number</span
                    ></v-col
                  >
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.basicCompanyInfo
                      .organisationNumber
                  }}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col><span class="company-info">Industry</span></v-col>
                  <v-col class="text-right">{{ companyInfo.industry }}</v-col>
                </v-row>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </Widget>
    </v-col>
    <v-col>
      <Widget class="fill-height">
        <v-card style="border-radius: 6px" flat class="fill-height">
          <div class="text-left">
            <v-card-text class="pa-6">
              <h2 class="text-left mb-2">Company address</h2>
              <div v-if="hasAddress" class="ml-2">
                <v-row no-gutters>
                  <v-col><span class="company-info">Address</span></v-col>
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.companyAddress.street
                  }}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col><span class="company-info">City</span></v-col>
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.companyAddress.city
                  }}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col><span class="company-info">Region</span></v-col>
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.companyAddress.region
                  }}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col><span class="company-info">Country</span></v-col>
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.companyAddress.country
                  }}</v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row class="mt-2">
                  <v-col>No company address registered.</v-col>
                </v-row>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </Widget>
    </v-col>
    <v-col>
      <Widget class="fill-height">
        <v-card style="border-radius: 6px" flat class="fill-height">
          <div class="text-left">
            <v-card-text class="pa-6">
              <h2 class="text-left mb-2">Contact person</h2>
              <div v-if="hasContactPerson" class="ml-2">
                <v-row no-gutters>
                  <v-col><span class="company-info">First Name</span></v-col>
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.contactPerson.firstName
                  }}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col><span class="company-info">Surname</span></v-col>
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.contactPerson.surname
                  }}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col><span class="company-info">Phone</span></v-col>
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.contactPerson.phone
                  }}</v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col><span class="company-info">Email</span></v-col>
                  <v-col class="text-right">{{
                    unitProfileStore.selectedUnitProfile.contactPerson.email
                  }}</v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row class="mt-2">
                  <v-col>No contact person registered.</v-col>
                </v-row>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </Widget>
    </v-col>
  </v-row>

  <v-row>
    <v-col cols="8">
      <QuestionnaireResponses />
    </v-col>
    <v-col cols="4">
      <Widget class="fill-height">
        <v-card style="border-radius: 6px" flat class="fill-height">
          <div class="text-left">
            <v-card-text class="pa-6">
              <h2 class="text-left mb-2">Countries of operation</h2>

              <v-table
                density="compact"
                v-if="
                  unitProfileStore.selectedUnitProfile.countriesOfOperation
                    .length > 0
                "
              >
                <tbody>
                  <tr
                    v-for="country in unitProfileStore.selectedUnitProfile
                      .countriesOfOperation"
                  >
                    <th>
                      <CountryText
                        :country-code="country.substring(0, 2)"
                        :region-country-code="country"
                      />
                    </th>
                  </tr>
                </tbody>
              </v-table>
              <div v-else>
                <v-row class="mt-2">
                  <v-col>No countries of operation registered.</v-col>
                </v-row>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </Widget>
    </v-col>
  </v-row>
  <div v-if="unitProfileStore.selectedUnitProfile.risks.length">
    <v-row class="mt-6">
      <v-col>
        <h1 style="color: black" class="text-left">Risk Indicators</h1>
      </v-col>
    </v-row>
    <UnitProfileFlagWidgets />
  </div>
</template>

<script setup lang="ts">
import HeaderWidget from "@/components/widgets/HeaderWidget.vue";
import { useUnitProfileStore } from "@/stores/unitProfileStore";
import Widget from "@/views/dashboard-view/Widget.vue";
import { computed } from "vue";
import UnitProfileFlagWidgets from "../unit-profile/UnitProfileFlagWidgets.vue";
import QuestionnaireResponses from "@/views/unit-profile/QuestionnaireResponsesWidget.vue";
import CountryText from "@/components/custom/CountryText.vue";
import { CompanyInfo } from "@/models/companyInfo";

const unitProfileStore = useUnitProfileStore();

const companyInfo: CompanyInfo = unitProfileStore.selectedUnitProfile.basicCompanyInfo;

const hasAddress = computed(
  () =>
    !Object.values(unitProfileStore.selectedUnitProfile.companyAddress).every(
      (a: string) => a === null || a === ""
    )
);

const hasContactPerson = computed(() => {
  return (
    unitProfileStore.selectedUnitProfile.contactPerson.firstName ||
    unitProfileStore.selectedUnitProfile.contactPerson.surname ||
    unitProfileStore.selectedUnitProfile.contactPerson.email ||
    unitProfileStore.selectedUnitProfile.contactPerson.phone
  );
});
</script>

<style scoped lang="scss">
.company-info {
  font-weight: 500;
  color: var(--grey);
}
</style>
